import request from '@/router/axios'
import BaseApi from '@/api/BaseApi';


let urlPrefix = '/api/lab/lesson2user'

/**
 * 获取成员(某课堂/某课堂实验)统计数据
 * @param {Object} params 
 * @param {String} params.lessonUid 课堂UID
 * @param {String} params.lessonExpUid 课堂实验UID
 * @param {Number} params.isSubmit 提交状态 0 未提交 1 已提交（未评分、已评分）
 * @param {Number} params.isGrade 评分状态（已提交） 0 未评分 1 已评分
 * @param {Number} params.isPass 合格状态（已提交） 0 未合格 1 合格
 * @param {Number} params.limit 每页条数
 * @param {Number} params.page 当前页码
 */
export const getLessonUserStatistics = (params = {}) => {
    return request(`${urlPrefix}/userStatistics`, { params })
};

/**
 * 学生退出课堂
 */
export const getOutClass = uid => {
    return request(`${urlPrefix}/${uid}/delete`, null, 'delete');
};

/**
 * 清退学生
 * @param {String} lessonUid 课堂uid
 * @param {Long} userId 学生id
 */
export const retreatUser = (lessonUid, userId) => {
    return request(`${urlPrefix}/${lessonUid}/${userId}/retreat`, null, 'delete');
};


// 指定时间内未做实验名单
export const specifyNotExpList = params => {
    return request(`${urlPrefix}/not/doexp/lessonusers`, { params });
};

class LabLesson2UserApi extends BaseApi {
    BASE_PATH = '/api/lab/lesson2user'
        
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return new LabLesson2UserApi();
    }
}

export default LabLesson2UserApi.instance()
